<script>
import Swal from "sweetalert2";
import {
  subscribeAndSendToBackend,
  disablePushSubscription,
  getPushSubscriptionStatus,
} from "@/helpers/webPushService";

export default {
  name: "PushNotificationsControl",
  data() {
    return {
      loading: false,
      statusLoading: false,
      pushSupported: false,
      pushEnabled: false,
      pushPermission: "default",
    };
  },
  created() {
    this.refreshStatus();
  },
  computed: {
    switchId() {
      return `push-notification-switch-${this._uid}`;
    },
    permissionLabel() {
      if (!this.pushSupported) return "Não suportado";
      if (this.pushPermission === "granted") return "Permitido";
      if (this.pushPermission === "denied") return "Bloqueado";
      return "Não definido";
    },
    statusVariant() {
      return this.pushEnabled ? "success" : "secondary";
    },
  },
  methods: {
    async refreshStatus() {
      this.statusLoading = true;
      try {
        const status = await getPushSubscriptionStatus();
        this.pushSupported = !!status.supported;
        this.pushEnabled = !!status.enabled;
        this.pushPermission = status.permission || "default";
      } catch (e) {
        this.pushSupported = false;
        this.pushEnabled = false;
        this.pushPermission = "unsupported";
      } finally {
        this.statusLoading = false;
      }
    },
    async onToggleNotifications(event) {
      const targetEnabled = !!event.target.checked;
      this.loading = true;
      try {
        if (targetEnabled) {
          const enabled = await subscribeAndSendToBackend();
          if (!enabled) {
            Swal.fire({
              icon: "info",
              title: "Notificações não habilitadas",
              text: "A permissão foi negada ou não foi possível concluir a ativação.",
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Notificações ativadas",
              text: "Você receberá notificações neste dispositivo.",
              timer: 1800,
              showConfirmButton: false,
            });
          }
        } else {
          await disablePushSubscription();
          Swal.fire({
            icon: "success",
            title: "Notificações desativadas",
            text: "As notificações foram desabilitadas neste dispositivo.",
            timer: 1800,
            showConfirmButton: false,
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Erro ao atualizar notificações",
          text: (e && e.message) || "Tente novamente em instantes.",
        });
      } finally {
        await this.refreshStatus();
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <h6 class="mt-3">Notificações</h6>
    <hr class="mt-1" />

    <p class="text-muted small mb-2">
      Ative ou desative as notificações push neste dispositivo.
    </p>

    <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
      <div>
        <span class="small d-block text-muted">Status</span>
        <b-badge :variant="statusVariant" class="mt-1">
          {{ pushEnabled ? "Ativas" : "Inativas" }}
        </b-badge>
      </div>
      <div class="text-muted small mt-2 mt-sm-0">
        Navegador: <strong>{{ permissionLabel }}</strong>
      </div>
    </div>

    <div class="custom-control custom-switch">
      <input
        :id="switchId"
        type="checkbox"
        class="custom-control-input"
        :checked="pushEnabled"
        :disabled="loading || statusLoading || !pushSupported"
        @change="onToggleNotifications"
      />
      <label class="custom-control-label" :for="switchId">
        {{ loading ? "Atualizando..." : "Receber notificações neste dispositivo" }}
      </label>
    </div>

    <div v-if="!pushSupported" class="alert alert-warning small mt-2 mb-0 py-2">
      Este navegador não suporta notificações push.
    </div>
  </div>
</template>
